import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../../services';
import {ErrorModel, ResultModel} from '../../../../models';
import {LoggerService} from '../../../../services';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_SALES';

export async function getSales(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getDashboardConsultantSales - Start');

        const getDashboardConsultantSales =
            await DashboardService.ConsultantService.SalesService.getSales(userData, params);

        LoggerService.logInfo('Action - getDashboardConsultantSales - End - Success');

        return ResultModel.newSuccessResult(getDashboardConsultantSales);
    }
    catch (error) {
        LoggerService.logInfo('Action - getDashboardConsultantSales - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
